import type { FC } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { AppBar, Box, Button, Toolbar } from '@mui/material';
import { ImageOutlined, MapOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import LogoWhite from '../LogoWhite';
import LogoMT from '../../res/img/Logo_MT.png';

const DashboardNavbar: FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  return (
    <AppBar sx={{ boxShadow: 'none', borderBottom: '1px solid rgba(255,255,255,.12)' }}>
      <Toolbar sx={{ minHeight: '64px !important', gap: { xs: 1, sm: 3 }, px: { xs: 1.5, sm: 2.5 } }}>
        <Box component={RouterLink} to="/" aria-label="Rete Limet" sx={{ display: { xs: 'none', sm: 'flex' },
          alignItems: 'center', gap: 1, color: 'inherit', textDecoration: 'none', flexShrink: 0 }}>
          <LogoWhite sx={{ height: 36, width: 36, display: 'block' }} />
          <Box component="span" sx={{ fontSize: 18, fontWeight: 700, letterSpacing: 1.5 }}>RETE LIMET</Box>
        </Box>
        <Box component="nav" aria-label="Navigazione principale" sx={{ display: 'flex', gap: 0.5,
          p: 0.5, borderRadius: '12px', backgroundColor: 'rgba(255,255,255,.09)',
          border: '1px solid rgba(255,255,255,.14)', width: { xs: '100%', sm: 'auto' } }}>
          {[{ path: '/', label: 'mappa_statica', icon: <ImageOutlined /> },
            { path: '/dynamicMap', label: 'mappa_dinamica', icon: <MapOutlined /> }].map(item => (
            <Button key={item.path} component={RouterLink} to={item.path} color="inherit"
              startIcon={item.icon} aria-current={location.pathname === item.path ? 'page' : undefined}
              sx={{ whiteSpace: 'nowrap', px: { xs: 1.25, sm: 2 }, py: 0.8,
                minHeight: 36, flex: { xs: 1, sm: 'initial' }, borderRadius: '8px',
                fontSize: { xs: 12, sm: 14 }, fontWeight: 600, textTransform: 'none',
                color: location.pathname === item.path ? '#0d0057' : 'rgba(255,255,255,.85)',
                backgroundColor: location.pathname === item.path ? '#fff' : 'transparent',
                boxShadow: location.pathname === item.path ? '0 1px 4px rgba(0,0,0,.18)' : 'none',
                '&:hover': { backgroundColor: location.pathname === item.path ? '#f0efff' : 'rgba(255,255,255,.12)' },
                '&.Mui-focusVisible': { outline: '2px solid #fff', outlineOffset: 3 },
                '& .MuiButton-startIcon': { mr: 0.75, '& svg': { fontSize: 19 } } }}>
              {t(item.label)}
            </Button>
          ))}
        </Box>
        <Box sx={{ flex: 1, display: { xs: 'none', sm: 'block' } }} />
        <Box component="a" href="https://meteotracker.com/" sx={{ display: { xs: 'none', sm: 'flex' },
          bgcolor: 'white', borderRadius: 1, p: 0.5 }}>
          <img src={LogoMT} alt="MeteoTracker" style={{ height: 30, width: 112, objectFit: 'contain' }} />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default DashboardNavbar;
